import { apiFetch } from './client';

export interface ReviewInput {
  stall_id: string;
  rating: 1 | 2 | 3 | 4 | 5;
  body?: string;
  language?: 'en' | 'th';
}

export interface Review {
  id: string;
  user_id: string;
  stall_id: string;
  rating: number;
  body: string;
  language: string;
  created_at: string;
  updated_at: string;
  photos: { object_key: string }[];
}

export const reviewsApi = {
  /** POST /v1/reviews — auth-required. Returns the created review. */
  submit: (input: ReviewInput, token: string) =>
    apiFetch<Review>('/v1/reviews', {
      method: 'POST',
      body: input,
      token,
    }),
};
